import { LitElement, html, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("katanoid-credit-indicator")
export class KatanoidCreditIndicator extends LitElement {
  protected override createRenderRoot(): HTMLElement {
    return this;
  }

  @property({ type: Number }) remaining = 0;
  @property({ type: Number }) total = 0;
  @property({ type: String }) level: "high" | "medium" | "low" = "high";

  protected override render(): TemplateResult {
    const pct = this.total > 0 ? Math.round((this.remaining / this.total) * 100) : 0;
    const fillClass =
      this.level === "low"
        ? "credit-bar-fill--critical"
        : this.level === "medium"
          ? "credit-bar-fill--low"
          : "";

    return html`
      <div class="credit-bar" aria-label="Credits: ${this.remaining} of ${this.total} remaining">
        <div class="credit-bar-track">
          <div
            class="credit-bar-fill ${fillClass}"
            style="width: ${pct}%"
          ></div>
        </div>
        <span class="credit-bar-label">
          ${this.remaining} of ${this.total} credits remaining
        </span>
        ${this.level === "low"
          ? html`<span class="credit-bar-warning">Running low — buy more credits</span>`
          : ""}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "katanoid-credit-indicator": KatanoidCreditIndicator;
  }
}
